/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { NotificationDtoFromJSON, NotificationDtoToJSON, } from './NotificationDto';
/**
 * Check if a given object implements the NotificationFeedResponse interface.
 */
export function instanceOfNotificationFeedResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function NotificationFeedResponseFromJSON(json) {
    return NotificationFeedResponseFromJSONTyped(json, false);
}
export function NotificationFeedResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : json['items'].map(NotificationDtoFromJSON)),
        'unreadCount': !exists(json, 'unreadCount') ? undefined : json['unreadCount'],
        'hasMore': !exists(json, 'hasMore') ? undefined : json['hasMore'],
        'serverTime': !exists(json, 'serverTime') ? undefined : (new Date(json['serverTime'])),
        'pollAfterSeconds': !exists(json, 'pollAfterSeconds') ? undefined : json['pollAfterSeconds'],
        'maxPollAfterSeconds': !exists(json, 'maxPollAfterSeconds') ? undefined : json['maxPollAfterSeconds'],
    };
}
export function NotificationFeedResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'items': value.items === undefined ? undefined : (value.items === null ? null : value.items.map(NotificationDtoToJSON)),
        'unreadCount': value.unreadCount,
        'hasMore': value.hasMore,
        'serverTime': value.serverTime === undefined ? undefined : (value.serverTime.toISOString()),
        'pollAfterSeconds': value.pollAfterSeconds,
        'maxPollAfterSeconds': value.maxPollAfterSeconds,
    };
}
